import BlogCard from "./BlogCard";export default function BlogSection({blogPosts,loading,error}){if(loading)return<p>Loading blog posts...</p>;if(error)return<p>Error loading blog posts.</p>;const recentPosts=blogPosts.slice(0,3);return(<section id="blog" className="blog py-5"><div className="container"><h2 className="text-center mb-5">Blog</h2><div className="row">{recentPosts.map((post)=>(<BlogCard
  key={post.sys.id}
  id={post.sys.id}
  title={post.fields.blogTitle}
  summary={post.fields.blogSummary}
  image={post.fields.blogImage.fields.file.url}
  date={new Date(post.fields.publishDate).toLocaleDateString()}
  author={post.fields.blogAuthor}/>))}</div></div></section>)}